import {EventEmitter} from 'events';
import {SCANNERS} from './ts-scan.settings';
//@ts-ignore
import {IScanService, ScanService} from '@techsee/techsee-client-infra/lib/services/ScanService';
import {IScanner, ITsScanService} from './contracts';
import {ITsCanvasAnnotateService} from '../ts-canvas-annotate/ts-canvas-annotate.service';
import TextScanner from './text-scanner';

export default class TsScanService extends EventEmitter implements ITsScanService {
    constructor(
        private tsCanvasAnnotate: ITsCanvasAnnotateService,
        private _scanService: IScanService
    ) {
        super();

        // Listen to canvas annotate events from the root store
        try {
            //@ts-ignore
            this.tsCanvasAnnotate.on('areaSelected', (...args: any[]) => {
                this.emit('areaSelected', ...args);
            });
        } catch (error) {
            console.warn('Could not connect to tsCanvasAnnotate service:', error);
        }
    }

    updateScanService(scanService: IScanService): void {
        if (scanService) {
            this._scanService = scanService;
        } else {
            console.warn('Scan service is not defined');
        }
    }

    getScanners(accountData: any, roomData: any): IScanner[] {
        if (!accountData?.protectedSettings?.imageAnalysis) {
            return [];
        }

        const scanners: IScanner[] = [];
        const settings = accountData.settings;
        const roomId = roomData?._id || '';

        if (settings?.textScanner) {
            scanners.push(new TextScanner(settings, roomId, this._scanService));
        }

        return scanners;
    }
}
